import {
  ACCOUNT_TYPE_DEFINITIONS,
  CONTACT_ROLE_DEFINITIONS,
  CONTACT_SOURCE_DEFINITIONS,
  PRIMARY_USE_DEFINITIONS,
  PROJECT_STAGE_DEFINITIONS,
  ROLE_FAMILY_DEFINITIONS,
} from '@parcel/types';
import type { WhereField } from '../types.js';
import { ENRICHMENT_OPTIONS, UNLOCKED_OPTIONS } from '../vocab.js';
import { fieldsIn, workspaceFields } from './shared.js';

const stages = PROJECT_STAGE_DEFINITIONS.map((d) => ({
  value: d.value,
  label: d.label,
  description: d.description,
}));
const c = fieldsIn('contact');
const f = fieldsIn('firm', 'firm');
const p = fieldsIn('project', 'project');

export const CONTACT_FIELDS: readonly WhereField[] = [
  c('name', 'Name', 'text', 'Full name.'),
  c('title', 'Title', 'text', 'Job title.'),
  c('persona', 'Persona', 'choice', 'Role family the title maps to.', {
    options: ROLE_FAMILY_DEFINITIONS,
  }),
  c('has_email', 'Has email', 'yes_no', 'Parcel knows their work email.'),
  c('email_verified', 'Email verified', 'yes_no', 'Their email has been verified.'),
  c('has_phone', 'Has phone', 'yes_no', 'Parcel knows their phone.'),
  c('has_linkedin', 'Has LinkedIn', 'yes_no', 'Parcel knows their LinkedIn profile.'),
  c('enrichment', 'Enrichment status', 'choice', 'How complete their profile is.', {
    options: ENRICHMENT_OPTIONS,
  }),
  c('source', 'Source', 'choice', 'Where Parcel found them.', {
    options: CONTACT_SOURCE_DEFINITIONS,
  }),
  c('unlocked', 'Unlocked', 'choice', 'What your workspace has unlocked.', {
    options: UNLOCKED_OPTIONS,
  }),
  c('projects_count', 'Number of projects', 'number', 'Projects they are linked to.', {
    unit: 'count',
  }),
  c('added', 'Added to Parcel', 'date', 'When the contact entered Parcel.'),

  f('name', 'Name', 'text', 'Their firm.'),
  f('type', 'Type', 'choice', 'What their firm does.', { options: ACCOUNT_TYPE_DEFINITIONS }),
  f('city', 'City', 'choice', "City of their firm's office.", { source: 'firm_cities' }),
  f('score', 'ICP Score', 'score', "Their firm's ICP Score, 0 to 100."),
  f('projects_count', 'Number of projects', 'number', 'Projects their firm is linked to.', {
    unit: 'count',
  }),

  p('role', 'Role', 'choice', 'Their role on the project.', { options: CONTACT_ROLE_DEFINITIONS }),
  p('city', 'City', 'choice', 'City of the project.', { source: 'cities' }),
  p('stage', 'Stage', 'choice', 'Development stage.', { options: stages }),
  p('use', 'Use', 'choice', 'Primary use.', { options: PRIMARY_USE_DEFINITIONS }),
  p('units', 'Units', 'number', 'Dwelling units.', { unit: 'units' }),
  p('cost', 'Construction cost', 'number', 'Construction cost in US dollars.', { unit: 'usd' }),
  p('last_signal', 'Last signal', 'date', 'Date of the newest signal.'),

  fieldsIn('scores')(
    'score',
    'Prospect Score',
    'score',
    "This workspace's Prospect Score, 0 to 100.",
  ),
  ...workspaceFields('contact'),
];
